import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { clearSubSystems, fetchSubSystems } from '../../../../store/slices/vehicle';

export const useFetchSubsystems = () => {
  const [loading, setLoading] = useState();
  const dispatch = useDispatch();
  const subsystems = useSelector(state => state.vehicle.subSystems);

  const fetchAllSubsystems = useCallback(() => {
    try {
      setLoading(true);
      if (subsystems.length === 0) {
        dispatch(fetchSubSystems());
      }
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    fetchAllSubsystems();
    return () => dispatch(clearSubSystems());
  }, [dispatch, fetchAllSubsystems]);

  return {
    loading,
    subsystems,
  };
};